import { useNavigate } from 'react-router-dom';
import "./Banner.css";
import { handleStart } from '../gameStart';

function BannerSection() {
   const navigate = useNavigate();

   const onNavigate = (path) => () => {
      console.log(`Navigating to ${path}`);
      navigate(path);
   }
   
   return (
      <div className="banner">
         <div className="bannerSection">
            <div className="bannerContent">

               <button className="bannerBtn" onClick={handleStart}>TEST YOUR KNOWLEDGE</button>
               <button className="bannerBtn" onClick={onNavigate('/learn')}>LEARNING RESOURCES</button>
           
            </div>
         </div>
      </div>
      
   );
 }
 
 export default BannerSection;